export const ROUTES_NAME = {
HOME:'/',
ABOUT:'/about',
SERVICES:'/services',
CONTACT_US:'/contact-us',
BOOK_A_DEMO:'/book-a-demo',
SIMULATION:'/simulations/:name',
PRIVACY_POLICY:'/privacy-policy',
TERMS_AND_CONDITIONS:'/terms-and-conditions'
}